import { Component, Input } from '@angular/core';
import { SubmittedConsultantInfo } from '@core/store/start-now-app/start-now-app-state-models';

@Component({
  selector: 'app-recruiter-info-card',
  templateUrl: './recruiter-info-card.component.html',
  styleUrls: ['./recruiter-info-card.component.scss'],
})
export class RecruiterInfoCardComponent {
  @Input() submittedConsultant: SubmittedConsultantInfo;
  constructor() {}
}
